export enum ContentNavigationType {
  Tiles = 'tiles',
  PaginationPoints = 'pagination-points',
}
